var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"blueLayout",class:_vm.size},[_c('w-icon',{staticClass:"iconUpgradeplan",attrs:{"icon":"shimmer","size":"small","color":"white"}}),_c('div',{staticClass:"labelUpgrade"},[_vm._v(_vm._s(_vm.$t('generic.upgrade')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }